export class IndexDB {
    // Increment this whenever anything changes
    private static DB_VERSION = 3;

    public static async saveArrayBuffer(id: string, state: Uint8Array): Promise<void> {
        const db = await this.getDatabase();
        if (db == null) return; // fail silently
        const tx = db.result.transaction('store', 'readwrite');
        const store = tx.objectStore('store');
        store.put({ id: id, state });

    }

    public static async getArrayBuffer(id: string): Promise<Uint8Array | undefined> {
        const db = await this.getDatabase();
        if (db == null) return undefined; // fail silently

        const tx = db.result.transaction('store', 'readwrite');
        const store = tx.objectStore('store');
        const doc = await this.getArrayBufferFromStore(id, store);
        return doc;
    }

    private static getArrayBufferFromStore(id: string, store: IDBObjectStore): Promise<Uint8Array | undefined> {
        const data = store.get(id);

        return new Promise((resolve) => {
            data.onsuccess = () => {
                if (data.result == undefined) {
                    resolve(undefined);
                } else {
                    resolve(data.result.state);
                }
            }
            data.onerror = () => {
                resolve(undefined);
            }
        });
    }

    private static getDatabase(): Promise<IDBOpenDBRequest | undefined> {
        return new Promise((resolve) => {
            const db = window.indexedDB.open('mydb', this.DB_VERSION);
            db.onupgradeneeded = () => {
                if (db.result.objectStoreNames.contains('store') == false) {
                    db.result.createObjectStore('store', { keyPath: 'id' });
                }
            };
            db.onsuccess = () => {
                resolve(db);
            }
            db.onerror = () => {
                resolve(undefined);
            }
        });
    }
}